{
  "topMenu": {
    "dihTitle": "データインテリジェンスハブ",
    "dihSubTitle": "データから安全に価値を抽出",
    "logout": "ログアウト",
    "dihPortal": "DIHポータル",
    "cofinityDataspace": "データスペースポータル",
    "portal": "ポータル"
  },
  "userLogoutAlert": {
    "title": "本当にログアウトしますか？",
    "back": "戻る",
    "logout": "ログアウト"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "ホーム",
    "collapse": "サイドバーを折りたたむ",
    "help": "ヘルプ",
    "prepare": "モデル管理",
    "model": "データモデル",
    "mapping": "データマッピング",
    "converter": "データコンバーター",
    "provide": "提供",
    "publishData": "データ公開",
    "assets": "アセット",
    "policyPublicationTemplate": "ポリシー公開テンプレート",
    "uploadHistory": "アセットアップロード履歴",
    "consume": "消費",
    "searchDataOffers": "データオファー検索",
    "negotiatedDataOffers": "交渉済みデータオファー",
    "downloadHistory": "アセットダウンロード履歴",
    "govern": "ガバナンス",
    "myPolicies": "マイポリシー",
    "createPolicies": "ポリシー作成",
    "policyTemplate": "ポリシーテンプレート",
    "manageAndConfig": "設定",
    "connections": "コネクター管理",
    "jobs": "処理ログ",
    "monitoring": "モニタリング",
    "licences": "ライセンス",
    "providedAgreements": "提供契約合意",
    "incomingAgreements": "受信データオファー",
    "consumedAgreements": "消費契約合意",
    "consumeAutomation": "消費ポリシー自動化",
    "networkAnalytics": "ネットワーク分析",
    "otherLogs": "その他のログ",
    "digitalTwin": "デジタルツインブラウザ",
    "messagesBrowserInbound": "受信メッセージ",
    "messagesBrowserOutbound": "送信メッセージ",
    "applications": "アプリケーション",
    "pcfExchange": "PCF交換",
    "pcfRequests": "PCFデータリクエスト",
    "pcfExchangeHistory": "PCFデータ交換履歴",
    "publicationTemplates": "公開テンプレート",
    "certificateManagement": "証明書管理",
    "certificates": "証明書",
    "connectors": "私のコネクタ",
    "contractDefinitions": "私の契約定義"
  },
  "versionModal": {
    "title": "一般情報",
    "error": "バージョンの詳細をフェッチできませんでした",
    "table": {
      "title": "コンポーネントの詳細",
      "componentName": "コンポーネント名",
      "imageVersion": "イメージバージョン",
      "chartVersion": "チャートバージョン"
    }
  },
  "dropdown": {
    "selectAll": "すべて選択",
    "noOption": "利用可能なオプションがありません",
    "noSuchOption": "そのようなオプションはありません...",
    "selectConnection": "接続を選択"
  },
  "certificateManagement": {
    "title": "ビジネスパートナー証明書管理",
    "description": "Catena-X の使いやすいエンドツーエンドのビジネスパートナー証明書交換ソリューションへようこそ。",
    "howTo": {
      "description": "他の Catena-X メンバー企業のデータ提供カタログを確認できます。証明書の提供を検索、選択、購読することが可能です。会社名で検索することもできます。",
      "doc": "ビジネスパートナー証明書管理の仕組みについてもっと知りたいですか？"
    },
    "landingTiles": {
      "tile_1": {
        "title": "発行証明書",
        "description": "Catena-Xネットワークでサイト証明書を作成して共有してください。"
      },
      "tile_2": {
        "title": "証明書を検出して消費する",
        "description": "サイトとビジネス証明書を簡単に検索してダウンロードします。"
      },
      "tile_3": {
        "title": "証明書公開の履歴",
        "description": "提供済み証明書の全体概要"
      },
      "tile_4": {
        "title": "使用済み証明書の履歴",
        "description": "使用した証明書の全体概要"
      },
      "tile_5": {
        "title": "受信証明書リクエスト",
        "description": "証明書共有のための受信リクエストの概要"
      },
      "tile_6": {
        "title": "送信証明書のステータス",
        "description": "証明書を共有するためのアクションの概要"
      },
      "tile_7": {
        "title": "証明書のリクエスト",
        "description": "サイトとビジネス証明書を簡単に検索してダウンロードします。"
      }
    },
    "recentCertificateRequests": "最近の受信証明書データリクエスト",
    "learnMore": "証明書管理について詳しく知る",
    "requestCertificates": "新しい証明書をリクエストする",
    "pushCertificate": "プッシュ証明書",
    "pushDescription": "既存の証明書は、下記で選択されたパートナーと共有されます。元のオファーと同じポリシーが適用されることにご注意ください。ポリシーを変更したい場合は、新しいデータオファーを作成してください。",
    "pushSuccess": "証明書のプッシュプロセスを開始しました!ジョブ ID は {id} です。",
    "receiverBpn": "受信者BPN",
    "providerBpn": "プロバイダーのBPN",
    "locationBpns": "サイト BPNA/BPNS",
    "certificateType": "証明書の種類",
    "requestSuccess": "証明書の要求が正常に送信されました!",
    "pushResult": "{total}件中{successful}件の{status}要求が成功しました!",
    "receiveConfirmTitle": "証明書の受領を確認",
    "receiveConfirmDesc": "「はい」をクリックすると、パートナーから共有された証明書を受け取ったことを確認します。提供者はあなたの確認を受け取ります。次のステップとして、証明書を承認または拒否できます。",
    "acceptedConfirmTitle": "証明書を承認",
    "acceptedConfirmDesc": "「はい」をクリックすると、証明書が期待に合っていることを承認します。表示アイコンをクリックすると、PDFとして証明書をダウンロードできます。",
    "rejectedConfirmTitle": "証明書を拒否",
    "rejectedConfirmDesc": "「はい」をクリックすると、受信した証明書を拒否します。提供者には拒否のステータスが通知されます。提供者は再度共有するか、あなたが新たに証明書を要求することができます。",
    "processStarted": "'{type}' プロセスが開始されました！ジョブIDは {id} です",
    "certificateDetails": "証明書の詳細",
    "availableCertificate": "利用可能な証明書の場所",
    "updateSuccess": "証明書が正常に更新されました！",
    "updateFailure": "証明書の更新に失敗しました！",
    "wizard": {
      "selectCompanies": "企業を選択してください",
      "selectPolicies": "ポリシーの選択"
    },
    "step1Description": "証明書を共有する会社を 1 つ以上選択します。 ",
    "step2Description": "証明書共有のポリシーを選択します。",
    "noPoliciesFound": "選択した企業のポリシーが見つかりませんでした。",
    "policiesFound": "{count} 個のポリシーが見つかりました",
    "selectedPolicies": "{count} 個が選択されました",
    "policyName": "ポリシー名",
    "bpn": "BPN",
    "policyType": "タイプ",
    "errorFetchingPolicies": "ポリシーの取得に失敗しました。",
    "assetId": "アセットID",
    "noPoliciesFoundInCatalog": "選択した企業のカタログにポリシーが見つかりません。",
    "duplicateBpnError": "同じBPNを2回選択することはできません。",
    "membershipValue": "メンバーシップ",
    "contractReference": "契約書参照"
  },
  "common": {
    "start": "開始",
    "firstName": "名",
    "lastName": "姓",
    "email": "メールアドレス",
    "phoneNumber": "電話番号",
    "contactPerson": "連絡担当者",
    "welcome": "ようこそ",
    "street": "住所",
    "city": "都市",
    "country": "国",
    "postCode": "郵便番号",
    "number": "番号",
    "next": "次へ",
    "prev": "戻る",
    "alreadyAccount": "すでにアカウントをお持ちですか？",
    "login": "ログイン",
    "loginNow": "今すぐログイン",
    "register": "登録",
    "home": "ホーム",
    "submit": "送信",
    "attention": "注意",
    "desc": "説明",
    "website": "ウェブサイト",
    "contact": "連絡先",
    "details": "詳細",
    "plan": "プラン",
    "table": "テーブル",
    "grid": "グリッド",
    "listView": "リストビュー",
    "gridView": "グリッドビュー",
    "firstPage": "最初のページへ",
    "previousPage": "前のページへ",
    "nextPage": "次のページへ",
    "lastPage": "最後のページへ",
    "paginationUnknownButton": "不明なページネーションボタンタイプ",
    "download": "ダウンロード",
    "delete": "削除",
    "edit": "編集",
    "information": "情報",
    "organization": "組織",
    "cancel": "キャンセル",
    "save": "保存",
    "upload": "アップロード",
    "link": "リンク",
    "view": "表示",
    "search": "検索",
    "searchTerm": "検索",
    "selectOption": "オプションを選択",
    "sortBy": "並べ替え",
    "dataspace": "データスペース",
    "select": "選択",
    "date": "日付",
    "title": "タイトル",
    "back": "戻る",
    "startTyping": "入力開始",
    "useCases": "ユースケース",
    "done": "完了",
    "enterValue": "値を入力",
    "selectValue": "値を選択",
    "selectDate": "日付を選択",
    "refresh": "更新",
    "searchByName": "名前で検索",
    "close": "閉じる",
    "copyToClipboard": "クリップボードにコピーしました！",
    "enterKeyName": "キー名を入力",
    "fileDownloadSuccess": "ファイルは正常にダウンロードされました",
    "fileDownloadError": "ファイルのダウンロードに失敗しました",
    "certificate": "証書",
    "manageConnections": "接続の管理",
    "confirm": "確認",
    "yes": "はい",
    "no": "いいえ",
    "connectionDetails": "{type}接続の詳細",
    "hide": "隠れる",
    "unpublish": "未発表",
    "clear": "クリア",
    "viewAll": "すべて見る",
    "apply": "適用する",
    "from": "から",
    "to": "に",
    "isRequired": "が必要です",
    "confirmationRequired": "チェックボックスをオンにして確認してください",
    "send": "送信",
    "update": "アップデート",
    "recentRequests": "最近のリクエスト",
    "severity": "重大度",
    "expectedResponseBy": "による予想される応答"
  },
  "genericError": "おっと、何か問題が発生しました！もう一度お試しください。",
  "validation": {
    "fieldRequired": "{field} は必須です。",
    "fieldNumeric": "フィールド {field} には数字のみを含めることができます。",
    "fieldAlpha": "フィールド {field} には文字、_、- のみを含めることができます。",
    "fieldAlphanumeric": "フィールド {field} には文字、数字、_、- のみを含めることができます。",
    "fieldNumericDash": "フィールド {field} には数字と - のみを含めることができます。",
    "fieldHouseNumber": "フィールド {field} には数字、文字、-、/ のみを含めることができます。",
    "fieldPhoneNumber": "フィールド {field} には数字と - のみを含め、+ または 00 で始まる必要があります。",
    "fieldAlphaDash": "フィールド {field} には文字と - のみを含めることができます。",
    "exceptHTMLTagBrackets": "フィールド {field} には次の文字を含めることはできません：^<>",
    "isMaxLength": "最大長10文字を超えています。",
    "emailFormat": "メールアドレスの形式が正しくありません",
    "fileSizeError": "ファイルサイズが {size} MB を超えています。",
    "csvFileSizeError": "ファイルが大きすぎます。最大 {size} MB のファイルをアップロードできます。",
    "csvFileExtensionError": "csv 拡張子のファイルのみ許可されています。",
    "csvFileIsEmptyError": "ファイルが空です。少なくとも {size} KB のファイルをアップロードする必要があります。",
    "csvFileFormatError": "ファイルの形式が期待される形式と一致しません。提供されたテンプレートを使用して再度お試しください。",
    "uploadFails": "アップロードに失敗しました",
    "fileExtensionError": "ファイルの拡張子が適切ではありません",
    "fileIsMalwareInfectedError": "このファイルにはマルウェアが含まれている可能性があります。セキュリティ上の理由から、このファイルはアップロードできません。ファイルを確認してください。",
    "customValidation": "{field} の形式が正しくありません。",
    "selectCountryFirst": "まず国名を選択してください",
    "validationPostCodeCaseDE": "フィールドの形式が正しくありません。5桁の数字（例：53113）でなければなりません",
    "validationAlphanumericCase": "フィールドには英数字、ダッシュ、アンダースコアのみを含めることができます。値は英数字で始まる必要があります。",
    "validationNumericDashCase": "フィールドには数字と - のみを含めることができます。",
    "url": "有効なURLを入力してください",
    "required": "このフィールドは必須です",
    "password": {
      "passwordStrength": "パスワードの強度",
      "weak": "弱い",
      "average": "平均",
      "strong": "強い",
      "passwordValidationMoreChar": "{count} 文字以上",
      "passwordUpperAndLowerChar": "大文字と小文字",
      "passwordAtLeastNumber": "少なくとも1つの数字",
      "passwordAtLeastSpecialChar": "少なくとも1つの特殊文字（<>&\"`[] 以外）",
      "passwordDiffFromPrev": "以前のパスワードと異なる"
    }
  },
  "footer": {
    "tagLine": "より高いパフォーマンスを支えよう",
    "imprint": "法的通知",
    "imprintShort": "通知",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "お問い合わせ",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "利用規約",
    "privacy": "プライバシーポリシー",
    "privacyShort": "プライバシー",
    "telekom": "T-Systems International GmbH。全権利を保有。",
    "telekomShort": "T-システムズ インターナショナル GmbH",
    "note": "テレコムデータインテリジェンスハブ - ビジネス顧客専用",
    "brandedNote": "テレコムデータインテリジェンスハブ提供",
    "help": "ヘルプ",
    "cookieSettings": "クッキー設定",
    "cookieSettingsShort": "クッキー",
    "life": "人生は共有のためにある"
  },
  "cookieSettings": {
    "collapsedTitle": "プライバシー設定",
    "collapsedText": "このウェブサイトはクッキーおよび類似の技術を使用しています。これらはコンピュータに保存され、読み取られる小さなテキストファイルです。「{0}」をクリックすることで、処理、ウェブサイトやパートナー間での個別ユーザー情報の作成、EU外（GDPR 第49条）の第三者へのデータ転送に同意します。詳細は{1}のセクション2を参照してください。データは分析、リターゲティング、テレコムサイトおよび第三者サイトでのパーソナライズされたコンテンツや広告の表示に使用されます。第三者プロバイダによるデータ処理や取り消しの可能性を含む詳細情報は、設定およびプライバシー情報に記載されています。ここでは{2}必要なツールのみで続行できます。",
    "extendedTitle": "プライバシー設定",
    "extendedText": "最適なウェブサイト体験を提供するため、クッキーを使用しています。これには、サイトの運用や最適化のためのクッキー、テキストやビデオチャットなどのサービス、オンライン利用行動に基づく広告のためのクッキーが含まれます。例えば、同じデバイスからの繰り返し訪問を検出できます。どのクッキーを許可するかを選択できます：",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "プライバシー情報",
    "policyLinkText": "プライバシー情報",
    "rejectLinkText": "続行",
    "acceptButton": "すべて受け入れる",
    "saveButton": "設定を保存",
    "settingsButton": "設定を変更",
    "showMore": "もっと表示",
    "showLess": "表示を減らす",
    "categoryTitleEssential": "必須クッキー",
    "categoryTitleAnalytics": "分析クッキー",
    "categoryTitleMarketing": "マーケティングクッキー",
    "categoryTitleThirdParty": "他社によるサービス（独立した第三者プロバイダ）",
    "categoryTextEssential": "これらのクッキーは、ウェブサイトを閲覧し、主要な機能を使用するために必要です。オンラインショップの注文処理やウェブページのセキュリティエリアへのアクセスなどの基本機能をサポートします。また、ユーザーパターンの匿名分析を行い、ウェブページの継続的な開発と改善に使用します。",
    "categoryTextAnalytics": "これらのクッキーは、ユーザー行動の理解を向上させるのに役立ちます。分析クッキーは、元のプロバイダまたは第三者プロバイダによる使用および識別データの収集を、匿名使用プロファイルにまとめることを可能にします。分析クッキーは、例えば、ウェブページやサービスの個々の訪問者数を把握し、製品のパフォーマンスに関する統計データを収集し、匿名および仮名情報に基づく訪問者の使用パターンと対話を分析するために使用されます。この情報は個人に遡及できません。",
    "categoryTextMarketing": "これらのクッキーおよび類似の技術は、パーソナライズされた、したがって関連性の高いマーケティングコンテンツの表示を可能にするために使用されます。マーケティングクッキーは、興味深い広告コンテンツを表示し、キャンペーンの効果を測定するために使用されます。これはテレコムのウェブサイトだけでなく、他の広告パートナーサイト（第三者プロバイダ）でも行われます。これはリターゲティングとも呼ばれ、仮名コンテンツや広告プロファイルを作成し、他のウェブサイトで関連広告を配置し、広告やコンテンツを閲覧したターゲットグループの洞察を導出するために使用されます。この情報は個人に遡及できません。マーケティングおよびリターゲティングツールは、関連性の高い広告コンテンツを提供するのに役立ちます。マーケティングクッキーを抑制しても、広告の表示量は変わりませんが、関連性が低くなる可能性があります。",
    "categoryTextThirdParty": "テレコムのウェブサイトには、独自の責任でサービスを提供する第三者サービスプロバイダへのリンクが含まれています。テレコムのウェブページを訪問すると、クッキーまたは類似の技術がデータを記録し、テレコム自身の目的のために一部を第三者に送信します。第三者自身の目的での処理の範囲、目的、法的根拠は、第三者のデータプライバシー情報で確認できます。独立した第三者プロバイダに関する情報は、データプライバシー情報で確認できます。"
  },
  "messages": {
    "noDataAvailable": "データがありません",
    "noMatchFound": "一致するものが見つかりません",
    "maximumFileSize": "最大ファイルサイズ",
    "suitableFileFormats": "適切なファイル形式",
    "loading": "読み込み中...",
    "dragDropText": "またはここにドラッグ＆ドロップ",
    "noConnectors": "コネクターが見つかりません！",
    "comingSoon": "近日公開"
  },
  "pageNotFound": {
    "title": "おっと！お探しのページはまだ存在しません。",
    "subtitle": "その間に、他の役立つリソースをご覧ください！"
  },
  "helpResources": {
    "needHelp": "適切なプランの選択、詳細情報、技術的な質問にお困りですか？",
    "developerDoc": "インテグレーター向けドキュメント",
    "developerDocDesc": "APIドキュメントを取得して開始",
    "example": "例",
    "tutorials": "チュートリアル",
    "exampleDescription": "あなたの産業分野に関連するユースケースやデモを見つける",
    "FAQ": "よくある質問",
    "FAQDescription": "請求からプライバシーまで、よくある質問の回答を見つける",
    "browse": "閲覧",
    "demos": "デモ",
    "demosDescription": "あなたの産業分野に関連するユースケースやデモを見つける",
    "glossary": "用語集",
    "glossaryDescription": "データインテリジェンスハブ、IDSA、Catena-X、Gaia-Xなどに関連する用語と定義を見つける。",
    "contactUs": "この機能は現在のサブスクリプションではサポートされていません。アップグレードするにはお問い合わせください。"
  },
  "feedbackCard": {
    "title": "さらにヘルプが必要ですか？",
    "contactUs": "お問い合わせ"
  },
  "error": {
    "pageNotFound": "ページが見つかりません (404)",
    "somethingWrong": "何か問題が発生しました！",
    "propertyNotFound": "プロパティが見つかりません",
    "uniquePropertyName": "プロパティ名は一意でなければなりません",
    "dctTypeNotFound": "dct:type が見つかりません"
  },
  "helpWidget": {
    "askSupport": "サポートに問い合わせる",
    "chatboxTitle": "ヘルプチャット",
    "chatboxSubtitle": "テレコムデータインテリジェンスハブサポート",
    "defaultMessage": {
      "body": "こんにちは、テレコムデータインテリジェンスハブのサポートチャンネルへようこそ。以下のオプションを選択してください。"
    },
    "whatCanWeHelpWith": "今日、どのようなお手伝いが必要ですか？",
    "suggestedAnswers": {
      "knowledgeBase": "ナレッジベース、ドキュメント、FAQ",
      "contactSupport": "サポートに連絡",
      "contactSales": "セールスに連絡"
    }
  },
  "pcfExchange": {
    "title": "PCF交換",
    "description": "Catena-Xにおける使いやすいエンドツーエンドの製品カーボンフットプリント（PCF）交換ソリューションへようこそ。",
    "recentRequests": "最近のPCFデータリクエスト",
    "viewAllRequests": "すべてのリクエストを表示",
    "requestPcf": "PCFをリクエスト",
    "termCheck": "リクエストを送信することで、データ提供者が設定したポリシーに基づいて契約が交渉されることを理解します。",
    "pcfSuccess": "PCFのリクエストが成功しました！",
    "landing": {
      "pcfTitle": "PCFオファー作成",
      "pcfDesc": "Catena-Xネットワーク内でPCFデータを作成し、参加者と共有。",
      "discoverTitle": "PCFデータの検索とリクエスト",
      "discoverDesc": "Catena-Xネットワーク内でPCFデータを簡単に検索するか、簡単な手順でパートナーからPCFデータをリクエスト。",
      "pcfReqTitle": "PCFデータリクエスト",
      "pcfReqDesc": "Catena-Xネットワーク内でのパートナーからのPCFデータリクエストを効率的に管理。",
      "pcfCalcTitle": "PCF計算機",
      "pcfCalcDesc": "PCF値を計算し、アプリケーションやPCFデータ交換シナリオにシームレスに接続。",
      "pcfHistoryTitle": "PCFデータ交換履歴",
      "pcfHistoryDesc": "Catena-XネットワークおよびパートナーでのPCFデータ交換履歴の透明性を確保。",
      "documentation": "PCFデータ交換について学ぶ",
      "howTo": {
        "description": "Catena-X内で製品カーボンフットプリント（PCF）データオファーを共有、発見、管理。",
        "doc": "接続と統合についてもっと知りたい？ドキュメントリンク："
      }
    },
    "requests": {
      "pcfRequests": "PCFデータリクエスト",
      "reqDesc": "このエリアを使用して、パートナーからのPCFデータリクエストを管理。",
      "productId": "製品ID*",
      "bpn": "BPN*",
      "message": "メッセージ",
      "howTo": {
        "title": "PCFデータリクエスト管理についてもっと知りたい？",
        "description": "このセクションを使用して、パートナーからのPCFデータリクエストを承認または拒否。さらに、PCFデータ交換の状態を確認し、PCFデータチェーンで完全な透明性を確保。",
        "doc": "データオファー交渉と消費の仕組みについてもっと知りたい？"
      }
    },
    "responses": {
      "howTo": {
        "description": "他のCatena-Xメンバー企業のデータオファーカタログを発見。データオファーを検索、選択、購読できます。会社名、製造者部品ID、またはその両方の組み合わせでデータオファーを検索できます。"
      }
    },
    "view": {
      "title": "PCF詳細を表示"
    }
  },
  "publicationTemplates": {
    "title": "マイ公開テンプレート",
    "deletedTemplates": "マイ削除済みテンプレート",
    "showDeletedTemplates": "削除済みテンプレートを表示",
    "hideDeletedTemplates": "アクティブなテンプレートを表示",
    "newTemplate": "新規テンプレート",
    "create": {
      "title": "公開テンプレート作成",
      "edit": "公開テンプレート編集",
      "templateName": "テンプレート名",
      "templateType": "{type} テンプレート",
      "create": "作成",
      "update": "更新",
      "name": "名前",
      "createdAt": "作成日",
      "modifiedAt": "修正日",
      "country": "国",
      "accessPolicyId": "アクセスポリシー",
      "usagePolicyId": "使用ポリシー",
      "id": "ID",
      "createdBy": "作成者",
      "modifiedBy": "修正者",
      "isEnabled": "有効",
      "targetCompany": "対象企業",
      "targetConnectors": "対象コネクター",
      "selectCountry": "国を選択",
      "templateDetails": "公開テンプレート詳細",
      "assetsCriteria": "アセット選択基準",
      "connectorDetails": "コネクター詳細"
    },
    "delete": {
      "title": "公開テンプレート削除",
      "description": "このテンプレートを削除しますか？",
      "button": "削除"
    }
  },
  "contracts": {
    "title": "契約合意詳細",
    "provider": {
      "description": "これはあなたの組織が他のデータスペース参加者と結んだ契約合意の概要です。",
      "howItWorks": {
        "description": "ここでは、さまざまなデータスペースにわたる購読または交渉済みのデータ合意をすべて確認できます。特定のコネクターで結果をフィルタリングしたり、契約合意IDまたはアセットIDで検索できます。必要に応じてリストを並べ替えることもできます。さらに、データオファーを選択してローカルにエクスポートできます。",
        "subtitle": "データオファー交渉と消費の仕組みについてもっと知りたい？"
      },
      "details": {
        "title": "提供契約合意詳細",
        "description": "説明",
        "content": "内容",
        "agreementDetails": "合意詳細",
        "assetDetails": "アセット詳細",
        "usagePolicy": "使用ポリシー"
      }
    },
    "consumer": {
      "description": "これはあなたの組織が他のデータスペース参加者のデータオファーに対して結んだ契約合意の概要です。",
      "downloadData": "データダウンロード",
      "downloadAgreement": "合意ダウンロード",
      "reinitiate": "転送開始＆データダウンロード",
      "error": {
        "heading": "申し訳ありません！この契約はすでに交渉済みです。",
        "body": "交渉済みの契約を再交渉することはできません。契約の詳細は以下で確認でき、合意をダウンロードしてデータを購読できます。"
      },
      "details": {
        "title": "消費契約合意詳細"
      },
      "howItWorks": {
        "description": "ここでは、さまざまなデータスペースにわたる購読または交渉済みのデータ合意をすべて確認できます。特定のコネクターで結果をフィルタリングしたり、契約合意IDまたはアセットIDで検索できます。必要に応じてリストを並べ替えることもできます。さらに、データオファーを選択してローカルにエクスポートできます。",
        "subtitle": "データオファー交渉と消費の仕組みについてもっと知りたい？"
      }
    }
  },
  "provider": {
    "provider": "提供者",
    "assets": {
      "title": "マイアセット",
      "offeredBy": "提供者：",
      "offers": "オファー",
      "created": "作成日",
      "modifiedAt": "修正日",
      "noResultsFound": "アセットが見つかりませんでした",
      "success": "アセット作成に成功",
      "updateSuccess": "アセット更新に成功",
      "buttons": {
        "createOffer": "オファー作成",
        "details": "詳細を表示",
        "delete": "アセット削除",
        "create": "アセット作成",
        "close": "閉じる",
        "edit": "アセット編集",
        "update": "アセット更新",
        "showDeleted": "削除済みアセットを表示",
        "hideDeleted": "削除済みアセットを非表示",
        "restore": "アセット復元",
        "save": "保存",
        "add": "キーバリューペアを追加",
        "addJson": "JSONオブジェクトを追加",
        "editJson": "JSONオブジェクトを編集",
        "saveJson": "JSONを保存",
        "advanceAddition": "高度な追加",
        "unpublish": "未発表の資産",
        "showAssets": "アセットを表示します"
      },
      "detailsDialog": {
        "title": "アセット詳細"
      },
      "createDialog": {
        "title": {
          "general": "新規アセット作成",
          "edit": "アセット編集",
          "addProperties": "プロパティ追加",
          "advance": "高度なプロパティ追加"
        },
        "publicProps": "公開プロパティ",
        "privateProps": "非公開プロパティ",
        "dataAddress": "データアドレス",
        "dataSources": "データソース",
        "dataDestination": "データ送信先",
        "json": {
          "fields": "JSONフィールド",
          "editor": "カスタムプロパティエディタ",
          "formatted": "カスタムプロパティビューア",
          "error": "無効なJSON："
        },
        "connectionTypeLabel": {
          "http": "URLを入力してください",
          "s3": "オブジェクト名を入力してください",
          "azure": "Blob名を入力してください",
          "sftp": "ファイル名を入力してください"
        },
        "fields": {
          "name": "名前",
          "namePlaceholder": "オファー名を入力",
          "id": "ID",
          "description": "説明",
          "contenttype": "コンテンツタイプ",
          "contenttypePlaceholder": "コンテンツタイプを入力",
          "contentType": "コンテンツタイプ",
          "contentTypePlaceholder": "コンテンツタイプを入力",
          "version": "バージョン",
          "keywords": "キーワード",
          "language": "言語",
          "languagePlaceholder": "言語を選択",
          "semanticId": "セマンティックID",
          "semanticIdPlaceholder": "セマンティックIDを入力",
          "dct:type": "DCT:タイプ",
          "dct:typePlaceholder": "dctタイプを選択",
          "keywordsPlaceholder": "キーワードを追加",
          "descriptionPlaceholder": "オファー説明を記述",
          "versionPlaceholder": "バージョン番号",
          "dataType": "データアドレスタイプ",
          "dataTypePlaceholder": "データアドレスタイプを選択",
          "dataAddressUrl": "アセットURL",
          "dataAddressUrlPlaceholder": "アセットURLを入力",
          "targetCompany": "対象企業",
          "targetCompanyPlaceholder": "対象企業を入力",
          "country": "国",
          "countryPlaceholder": "国を入力",
          "key": "キー",
          "keyPlaceholder": "キーを入力",
          "value": "値",
          "valuePlaceholder": "値を入力",
          "assetType": "アセットタイプ",
          "assetTypePlaceholder": "アセットタイプを入力"
        },
        "validation": {
          "name": "名前を入力してください",
          "assetType": "アセットタイプを選択してください",
          "contentType": "有効なコンテンツタイプを入力してください",
          "dataType": "有効なデータタイプを選択してください",
          "targetCompany": "有効な対象企業を入力してください",
          "country": "有効な国を入力してください"
        }
      },
      "tags": {
        "restricted": "アクセス制限",
        "unrestricted": "無制限"
      },
      "search": {
        "title": "検索フィルター",
        "helperText": "アセット名、作成日、またはタイプで検索",
        "filters": {
          "byName": "アセット名",
          "byType": "アセットタイプ",
          "byDate": "修正日"
        }
      },
      "delete": {
        "title": "アセット削除",
        "description": "このアセットを削除しますか？"
      },
      "unpublish": {
        "title": "未発表の資産",
        "description": "この資産を未発表したいですか？"
      }
    },
    "fileUploadTerms": "私は、必要な情報をすべて正しく入力し、T-Systemsが誤った情報を提供した場合に責任を負わないことを理解し、確認します。",
    "fileUploadInfo": "T-Systemsは、ここに入力されたメタデータ情報の有効性を確認しません。正確で完全な情報を入力したことを確認してください。",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "シングルエントリ",
    "bulkEntries": "一括入力"
  },
  "home": {
    "title": "接続と統合"
  },
  "gettingStarted": {
    "title": "開始にヘルプが必要ですか？",
    "openWizard": "ウィザードを開く",
    "yourDataOffering": "あなたのデータオファー",
    "yourAssets": "アセット",
    "yourPolicies": "マイポリシー",
    "preconfiguredCatalogue": "事前設定カタログ",
    "contractAgreements": "契約合意",
    "incomingAgreements": "受信合意",
    "outgoingAgreements": "送信合意",
    "connectors": "あなたのコネクター",
    "providedAgreements": "提供契約合意",
    "consumedAgreements": "消費契約合意"
  },
  "yourConnection": {
    "title": "あなたのコネクター",
    "viewAllConnection": "すべてのコネクターを表示",
    "help": "ヘルプ",
    "documentation": "接続と統合について知る",
    "gettingStarted": "入門ガイド",
    "noUseCases": "利用可能なユースケースがありません"
  },
  "wizardSelectionPopup": {
    "whatToLike": "今日、どのようなことをしたい？",
    "prepare": "準備",
    "govern": "ガバナンス",
    "provide": "提供",
    "consume": "消費",
    "howToProvide": "今日、どのようにデータを提供したい？",
    "manual": "手動",
    "automated": "APIを介した自動化",
    "selectUseCases": "ユースケースを選択",
    "selectSingleUseCase": "ユースケースを選択",
    "selectDigitalTwin": "デジタルツインタイプを選択",
    "back": "戻る",
    "next": "次へ",
    "publish": "データスペースのフレームワーク要件を理解し、組織を代表してデータスペースでデータオファーを公開することに同意します。"
  },
  "createOffer": {
    "title": {
      "standard": "データオファー作成",
      "pcf": "PCFデータオファー作成",
      "certificate": "証明書オファーの作成"
    },
    "publish": "公開",
    "legalConfirmation": "データスペースのフレームワーク要件を理解し、組織を代表してデータスペースでデータオファーを公開することに同意します。",
    "wizard": {
      "provisionAsset": "アセット提供",
      "dataUpload": "データ選択",
      "attachPolicy": "ポリシー添付",
      "publishDataOffer": "データオファー公開"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "どのサブモデルでデータオファーを作成したい？",
      "selectSubmodel": "サブモデルを選択",
      "selectUsecase": "ユースケースを選択",
      "selectDigitalTwinType": "デジタルツインタイプを選択",
      "whichTypeToSelect": "どのタイプを選ぶべき？",
      "generalInformation": "一般情報",
      "name": "名前",
      "id": "ID",
      "description": "説明",
      "contentType": "コンテンツタイプ",
      "version": "バージョン",
      "keywords": "キーワード",
      "language": "言語",
      "location": {
        "title": "位置とアドレス",
        "text": "アセットの詳細を入力してください"
      },
      "username": "ユーザー名",
      "password": "パスワード",
      "assetUrl": "アセットURL",
      "assetUrlPlaceHolder": "アセットURLを入力してください",
      "clientId": "クライアントID",
      "clientSecret": "クライアントシークレット",
      "tokenUrl": "トークンURL",
      "tokenUrlPlaceHolder": "トークンURLを入力してください",
      "provideAssets": "アセット提供",
      "selectConnectorLabel": "データを共有したいコネクターを選択",
      "selectConnectorPlaceholder": "コネクターを選択",
      "selectRestApiType": "REST-APIタイプを選択",
      "selectedAuthMethod": "認証方法"
    },
    "dataUpload": {
      "selectedDataModel": "データ選択",
      "csvUpload": {
        "title": "CSVファイル",
        "description": "ここにファイルをドラッグ＆ドロップしてください",
        "uploadFile": "ファイル選択",
        "uploadFileDescription": "交換したいファイルを準備してアップロード。Catena-Xに必要な形式を始めるためにサンプルファイルをダウンロードできます。",
        "uploadFileDescriptionNote1": "以下のリンクからテンプレートファイルをダウンロード",
        "uploadFileDescriptionNote2": "提供されたファイルにパートナーの詳細を入力",
        "uploadFileDescriptionNote3": "提供されたエリアにファイルをアップロード",
        "partnerValidationNote": "パートナー検証についてもっと知りたい場合は、",
        "clickHere": "こちらをクリック",
        "downloadTemplate": "テンプレートをダウンロード",
        "downloadSampleCsv": "サンプルCSVをダウンロード",
        "supportedFileTypes": "サポートされているファイルタイプ:"
      },
      "jsonUpload": {
        "title": "JSON",
        "description": "カスタムjsonコードを記述してください"
      },
      "tableUpload": {
        "title": "テーブル",
        "description": "カスタムテーブルエントリを入力してください",
        "add": "追加"
      },
      "fileUpload": {
        "title": "ファイルアップロード",
        "description": "CSV、JSON"
      },
      "objectStorage": {
        "title": "オブジェクトストレージ",
        "description": "AWS、Azure、OTC、またはGCP"
      },
      "sftp": {
        "title": "SFTPサーバー",
        "description": "SFTPを介した転送"
      },
      "apiUpload": {
        "title": "REST API",
        "description": "APIを介した転送",
        "authAndIdentiTitle": "認証と識別",
        "authAndIdentiDesc": "送信先システムの認証詳細を入力してください",
        "selectApiType": "REST-APIタイプを選択",
        "locationAndAddrTitle": "位置とアドレス",
        "locationAndAddrDesc": "アセットの詳細を入力してください",
        "assetUrl": "アセットURL",
        "username": "ユーザー名",
        "password": "パスワード",
        "clientId": "クライアントID",
        "clientSecret": "クライアントシークレット"
      }
    },
    "fileUpload": {
      "title": "ここにファイルをドラッグ＆ドロップ",
      "btnText": "ファイル選択"
    },
    "attachPolicy": {
      "title": "このデータオファーにポリシーを添付",
      "createPolicy": "新しいポリシー作成",
      "bpnFieldTitle": "誰とデータを交換したい？",
      "howItWork": {
        "title": "どのように機能する？",
        "description": "Catena-Xユースケースフレームワーク合意に基づいてポリシーを事前設定。提供されたビジネスパートナーナンバーにのみデータアクセスが許可されます。",
        "knowMore": "ポリシーについてもっと知りたい？",
        "documentation": "ドキュメント"
      },
      "accessPolicyTableText": "このデータオファーにアクセスポリシーを添付",
      "usagePolicyTableText": "このデータオファーに使用ポリシーを添付",
      "heading": {
        "title": "既存ポリシーを添付または新規作成",
        "description": "データオファー公開を完了するには、以下のテーブルからアクセスおよび使用ポリシーを添付してください。ポリシー名でポリシーを検索したり、希望のポリシーがない場合は新しいポリシーを作成できます。"
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "データオファー詳細",
      "generalInformation": "一般情報",
      "attribute": "属性",
      "value": "値",
      "knowMore": "データオファーについてもっと知る",
      "attachedDataAssets": "添付アイテム",
      "attachedPolicies": "添付ポリシー",
      "allowPolicyPublish": "ポリシー公開を許可",
      "publish": "公開",
      "verifiedLegalEntity": "検証済み法人：",
      "dataOfferCreatedBy": "データオファー作成者：",
      "contactOrgAdmin": "組織管理者へ連絡",
      "help": "ヘルプ",
      "attachedDataAsset": "添付データアセット",
      "attachedAccessPolicy": "添付アクセスポリシー",
      "attachedUsagePolicy": "添付使用ポリシー",
      "publishedConnectors": "このオファーが公開されるコネクター",
      "knowMoreConnector": "コネクターについてもっと知る",
      "knowMorePolicies": "ポリシーについてもっと知る",
      "knowMoreDataAssets": "データアセットについてもっと知る",
      "knowMoreDataOffers": "データオファーについてもっと知る",
      "publishCheckboxLabel": "私は組織を代表して、データスペースでデータオファーとアセットを公開することに同意します。関連ポリシーを使用してデータスペースを管理し、関連ポリシーおよびデータスペースのフレームワークに従って公開後のオファーやアセットに関する操作を行います。"
    },
    "result": {
      "success": {
        "title": "リクエスト成功。",
        "description": "アセット公開プロセスが開始しました！ジョブIDは {id} です"
      }
    },
    "success": {
      "title": "データオファーが公開されました",
      "description": "データオファーが公開されました。次のステップについては以下をクリックしてください",
      "createOffer": "別のデータオファーを作成",
      "createOfferButton": "作成",
      "goToHome": "ホームに戻る",
      "goToHomeButton": "ホームに戻る",
      "uploadHistory": "アップロード履歴を確認"
    }
  },
  "policy": {
    "newPolicy": "新規ポリシー",
    "showDeletedPolicies": "削除済みポリシーを表示",
    "myDeletedPolicies": "マイ削除済みポリシー",
    "hideDeletedPolicies": "アクティブなポリシーを表示",
    "restoreAsset": "復元",
    "publishDeletion": "削除公開",
    "create": {
      "title": "新規ポリシー作成",
      "edit": "ポリシー編集",
      "policyName": "ポリシー名",
      "policyType": "{type} ポリシー",
      "accessPolicy": "アクセスポリシー",
      "usagePolicy": "使用ポリシー",
      "create": "作成して保存",
      "update": "更新"
    },
    "delete": {
      "title": "ポリシー削除",
      "description": "このポリシーを削除しますか？",
      "button": "削除"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "ビジネスパートナー番号",
        "description": "ビジネス パートナー数の制限は、(BPNL に基づいて) どのビジネス パートナーがそれぞれのデータ オファーの表示または交渉を許可されるかを定義するために使用できます。"
      },
      "BusinessPartnerGroup": {
        "title": "ビジネスパートナーグループ",
        "description": "ビジネス パートナー グループ制限は、(BPNL に基づいて) どの正確なビジネス パートナーがそれぞれのデータ オファーの表示または交渉を許可されるかを定義するために使用できます。"
      },
      "Membership": {
        "title": "メンバーシップ",
        "description": "メンバーシップ資格情報を使用して、CX メンバーのみがそれぞれのデータ オファーを表示または交渉できるようにすることができます。"
      },
      "ContractReference": {
        "title": "契約リファレンス",
        "description": "契約参照制限は、どの二国間契約の詳細に基づいてデータが共有されるかを定義するために使用できます。"
      },
      "Dismantler": {
        "title": "解体業者",
        "description": "この資格を保有する企業は解体業者認定企業です。",
        "allowedBrands": {
          "title": "解体業者許可ブランド",
          "description": "解体業者を定義する会社の役割。この資格を保有する企業は解体業者認定企業です。"
        }
      },
      "UsagePurpose": {
        "title": "利用目的",
        "description": "利用目的"
      },
      "FrameworkAgreement": {
        "title": "枠組み合意",
        "description": "FrameworkAgreement 資格情報を使用すると、それぞれのフレームワーク契約 (一般または特定のバージョン経由) に署名した参加者のみが、それぞれのデータ オファーを表示または交渉することができます。"
      },
      "Duration": {
        "title": "間隔",
        "description": "署名日からのデータ使用期間。"
      },
      "inForceDate": {
        "title": "固定日付範囲",
        "description": "データ使用量の固定日付時間枠。"
      },
      "connector": {
        "title": "コネクタの制限",
        "description": "そこに使用するコネクタを保有する企業には制限があります。"
      }
    },
    "fields": {
      "BusinessPartnerNumber": "ビジネスパートナー番号",
      "tx:BusinessPartnerGroup": "ビジネスパートナーグループ",
      "cx-policy:Membership": "メンバーシップ",
      "cx-policy:ContractReference": "契約リファレンス",
      "cx-policy:Dismantler.allowedBrands": "解体業者許可ブランド",
      "cx-policy:Dismantler": {},
      "cx-policy:UsagePurpose": "利用目的",
      "cx-policy:FrameworkAgreement": "枠組み合意",
      "duration": "間隔",
      "unit": "ユニット",
      "fromdate": "開始日",
      "todate": "現在まで",
      "connector": "コネクタ"
    }
  },
  "jobs": {
    "jobs": "ジョブ",
    "id": "ID",
    "name": "名前",
    "startedAt": "開始日時",
    "status": "ステータス",
    "duration": "期間",
    "action": "アクション",
    "jobDetails": "処理詳細",
    "reload": "再読み込み",
    "noDetailsAvailable": "このジョブの詳細情報はありません",
    "retry": "再試行"
  },
  "search-offer": {
    "pageTitle": "データオファー検索",
    "pcfTitle": "PCFデータオファー検索",
    "certificateTitle": "ビジネスパートナーの証明書オファーを検索します",
    "filter": {
      "bpnSearch": "ビジネスパートナーナンバーまたは会社名で検索",
      "bpnSearchNote": "会社名またはBPNでデータオファーを検索。",
      "manufacturePartId": "製造者部品ID",
      "manufacturePartIdNote": "指定された部品IDに一致するすべてのデータオファーを検索。",
      "enter": "{field} を入力",
      "connectorUrl": "コネクターURL",
      "connectorUrlNote": "特定のコネクター内でデータを検索",
      "subModel": "サブモデル",
      "subModelNote": "希望するユースケースに合わせて検索結果を調整",
      "search": "検索",
      "searchBy": "検索条件",
      "resetFilters": "フィルターをリセット",
      "advancedSearch": "高度な検索",
      "name": "名前",
      "dct:type": "DCT:タイプ",
      "assetId": "アセットID"
    },
    "noResult": {
      "title": "結果なし",
      "description": "ネットワークで利用可能なデータオファーを閲覧するには検索してください"
    },
    "helpCard": {
      "title": "どのように機能する？",
      "description": "他のデータスペース参加者のデータオファーカタログを発見。データスペースで利用可能なデータオファーを検索、選択、購読できます。",
      "subtitle": "データオファー交渉と消費の仕組みについてもっと知りたい？",
      "documentation": "ドキュメント"
    },
    "offers": {
      "downloadSelected": "選択したものをダウンロード",
      "transferSelected": "選択したものを転送",
      "negotiate": "交渉",
      "noOffer": "データオファーがありません。"
    },
    "offer-details": {
      "title": "契約交渉の確認",
      "description": "説明",
      "details": "詳細",
      "attachedPolicies": "添付ポリシー",
      "termsCheck": "契約条件に同意し、契約交渉とデータ交換を開始します。",
      "negotiate": "交渉",
      "negotiateAndDownload": "交渉してダウンロード",
      "negotiateAndTransfer": "交渉して転送",
      "transfer": "転送",
      "cancel": "キャンセル",
      "attribute": "属性",
      "value": "値",
      "endpointUrl": "エンドポイントURL",
      "organization": "組織",
      "bpnNumber": "BPN番号",
      "manufacturerPartId": "製造者部品ID",
      "noOfAssets": "選択したアセット数",
      "membership": "メンバーシップ",
      "dismantlerBrands": "許可された解体ブランド",
      "frameworkAgreement": "フレームワーク合意",
      "dismantler": "解体者",
      "backToAssets": "アセットに戻る",
      "noPolicyMatchTitle": "アセット未交渉またはポリシーが一致しない",
      "noPolicyMatchText": "交渉されていないアセットをダウンロードしようとしています。あるいは、交渉しようとしているアセットのポリシーが一致しません。正しいアセットを選択して続行してください。",
      "negotiateInProgress": "交渉とダウンロードが進行中",
      "negotiateAndDownloadSuccess": "交渉とダウンロードが正常に完了",
      "negotiateAndTransferSuccess": "交渉と転送が正常に完了",
      "transferSuccess": "転送が正常に完了",
      "progress": "進捗",
      "fetchShell": "シェル取得",
      "exportToCSV": "CSVにエクスポート",
      "fetchJobFailed": "ジョブ詳細の取得中にエラー",
      "negotiateError": "アセットのダウンロード中にエラー",
      "dtr": "デジタルツインレジストリ",
      "edc": "コネクターアセット",
      "browseDtr": "DTRを閲覧"
    },
    "dtr": {
      "title": "デジタルツインシェル",
      "shells": "シェルを閲覧",
      "description": "選択したプロバイダのデジタルツインレジストリからシェルの取得とエクスポートを自動的に交渉します",
      "noPoliciesFound": "この資産に対するポリシーが見つかりませんでした",
      "errorFetchingPolicies": "ポリシーの取得中にエラーが発生しました。",
      "negotiate": "交渉する"
    }
  },
  "assetUploadHistory": {
    "title": "アセットアップロード履歴",
    "subtitle": "この履歴は、企業のデータスペースコネクターでのトランザクションの概要を示します。アセット、ポリシー、契約定義に関するすべての活動がここに一覧表示されます。",
    "refresh": "更新",
    "processId": "プロセスID",
    "providerUrl": "プロバイダURL",
    "createdOn": "作成日",
    "totalItems": "総アイテム",
    "successful": "成功",
    "failed": "失敗",
    "startDate": "開始日",
    "endDate": "終了日",
    "status": "ステータス",
    "actions": "アクション",
    "howItWork": {
      "title": "どのように機能する？",
      "description": "さまざまなデータスペースにわたるすべてのアップロードされたアセットの履歴を確認できます。ファイルをローカルに再ダウンロードしたり、外部の場所に転送できます。エラーが発生した場合は、ダウンロードを再試行するか、データオファーを再交渉する必要があります。",
      "moreInfo": "アップロード履歴やここでできることについてもっと知りたい？"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "この履歴は、データスペースの交渉済み契約から組織がダウンロードしたデータの概要を提供します。必要に応じて、この履歴リストからデータを再度ダウンロードできます。",
    "howItWorks": {
      "description": "さまざまなデータスペースにわたるすべてのダウンロードされたアセットの履歴を確認できます。ファイルをローカルに再ダウンロードしたり、外部の場所に転送できます。エラーが発生した場合は、ダウンロードを再試行するか、データオファーを再交渉する必要があります。",
      "moreInfo": "ダウンロード履歴やここでできることについてもっと知りたい？"
    },
    "downloadError": "ダウンロードに失敗しました。もう一度お試しください！",
    "viewErrors": "エラーを表示"
  },
  "digitalTwinBrowser": {
    "subHeading": "これらはあなたのデジタルツインとそのサブモデルです。デジタルツインはデジタルツインレジストリを通じてデータスペースに公開されます。",
    "noDocumentError": "現在のIDにaspectDocumentがありません",
    "nameNotProvided": "名前が提供されていません",
    "fetchDigitalTwinsError": "デジタルツインの取得に失敗",
    "fetchAspectDocumentError": "アスペクトドキュメントの取得に失敗",
    "fetchAspectModelError": "アスペクトモデルの取得に失敗",
    "detailsOverviewModalTitle": "アスペクト詳細",
    "addItem": "アイテム追加",
    "detailsTable": {
      "id": "ID",
      "idShort": "短いID",
      "displayName": "表示名",
      "modelUrn": "モデルURN"
    },
    "shellsTable": {
      "id": "ID",
      "name": "名前",
      "manufacturer": "製造者部品ID",
      "modifiedBy": "ユーザー",
      "modifiedAt": "時間"
    }
  },
  "connector": {
    "addNewConnector": "+ 新しいコネクタを追加",
    "searchConnector": "コネクタ名で検索",
    "connectorModal": {
      "error": "コネクタの詳細を取得できませんでした"
    }
  },
  "column": {
    "name": "名前",
    "connectorName": "コネクタ名",
    "contractId": "契約ID",
    "productId": "製品ID",
    "manufacturerPartId": "製造者部品ID",
    "manufacturerId": "製造者ID",
    "digitalTwinType": "デジタルツインタイプ",
    "correlationId": "相関ID",
    "requestId": "リクエストID",
    "bpn": "BPN",
    "createdAt": "作成日",
    "createdBy": "作成者",
    "attribute": "属性",
    "url": "URL",
    "actions": "アクション",
    "lastUpdatedTime": "最終更新日時",
    "status": "ステータス",
    "requestedDate": "リクエスト日",
    "policyType": "ポリシータイプ",
    "modifiedBy": "修正者",
    "modifiedOn": "修正日",
    "syncStatus": "同期ステータス",
    "assetId": "アセットID",
    "assetType": "アセットタイプ",
    "type": "タイプ",
    "createdFrom": "作成開始",
    "createdTo": "作成終了",
    "statusDuration": "ステータス/期間",
    "certifier": "認証者",
    "version": "バージョン",
    "registrationNumber": "登録番号",
    "validUntil": "有効期限",
    "offerId": "オファー ID",
    "errorMessage": "エラーメッセージ",
    "globalAssetId": "グローバル資産ID",
    "shellName": "シェル名",
    "contractAgreementId": "契約合意ID",
    "signingDate": "署名日",
    "providerConnectorUrl": "プロバイダーコネクタURL",
    "consumerConnectorUrl": "コンシューマーコネクタURL",
    "providerBpnl": "プロバイダーBPNL",
    "consumerBpnl": "コンシューマーBPNL",
    "counterPartyId": "カウンターパーティーID",
    "resourceId": "リソースID",
    "resourceType": "リソースタイプ",
    "transactionMethod": "トランザクション方法",
    "trustLevel": "信頼レベル",
    "partId": "部品ID",
    "intrinsicId": "本質的なID"
  },
  "messagesBrowser": {
    "fetchMessagesError": "メッセージの取得に失敗",
    "openRelatedMessage": "関連メッセージを開く",
    "messagesTable": {
      "id": "ID",
      "name": "名前",
      "createdAt": "作成日",
      "createdBy": "作成者",
      "type": "タイプ",
      "context": "コンテキスト",
      "senderBpn": "送信者BPN",
      "receiverBpn": "受信者BPN",
      "correlationId": "相関ID",
      "jobId": "ジョブID",
      "conversationId": "会話ID",
      "status": "ステータス"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "一般",
      "quality": "品質",
      "ccmpush": "CCMプッシュ",
      "ccmrequest": "CCMリクエスト",
      "ccmstatus": "CCMステータス",
      "ccmavailable": "CCM利用可能",
      "blockNotification": "ブロック通知",
      "dtrEvent": "DTRイベント",
      "alert": "アラート",
      "investigation": "調査"
    }
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "基本的な証明書情報",
        "issuer": "発行者情報",
        "validity": "有効期間",
        "trust": "信頼情報",
        "validator": "バリデーター情報",
        "application": "アプリケーションエリア",
        "enclosedSites": "囲まれたサイト"
      },
      "fields": {
        "businessPartnerNumber": "ビジネスパートナー番号",
        "registrationNumber": "登録番号",
        "certificateType": "証明書の種類",
        "certificateVersion": "証明書バージョン",
        "issuerName": "発行者名",
        "issuerBpn": "発行者BPN",
        "validFrom": "から有効です",
        "validUntil": "有効になるまで",
        "trustLevel": "信頼レベル",
        "uploaderBpn": "アップローダーBPN",
        "validatorBpn": "バリデーターBPN",
        "validatorName": "バリデーター名",
        "areaOfApplication": "アプリケーションの領域",
        "siteBpn": "サイトBPN",
        "siteAreaOfApplication": "アプリケーションのサイトエリア"
      },
      "tooltips": {
        "basicInfo": "ビジネスパートナー証明書は、Catena-Xビジネスパートナーの証明書ドキュメントを介して証明書（ISO9001、IATF-16949など）について説明します",
        "businessPartnerNumber": "認定された法人のビジネスパートナー番号（BPN）（証明書が発行される）。",
        "registrationNumber": "証明書で定義されている証明書の登録番号",
        "certificateType": "ドキュメントで定義されている証明書のタイプ、有効なタイプはBPN Metadatacontrollerで登録されます",
        "certificateVersion": "ドキュメントで定義されている証明書のバージョン、通常は認証標準の特定のバージョン",
        "issuerName": "発行者の名前、つまり認証機関。",
        "issuerBpn": "発行者のビジネスパートナー番号（BPN）。",
        "validFrom": "証明書で定義されている日付から有効。",
        "validUntil": "証明書で定義されている場合に有効な有効。",
        "trustLevel": "指定された証明書の信頼レベル - なし、低、高、信頼",
        "uploaderBpn": "最初に認定データまたはドキュメントを提供したビジネスパートナーのビジネスパートナー番号（BPN）。",
        "validatorBpn": "指定された証明書を検証したデータサービスプロバイダーのビジネスパートナー番号（BPN）",
        "validatorName": "指定された証明書を検証したデータサービスプロバイダーのオプション名",
        "areaOfApplication": "どの領域 /アプリケーションタイプの詳細証明書が会社やサイトに有効です。",
        "siteBpn": "囲まれたサイトのビジネスパートナー番号（BPNSまたはBPNA）",
        "siteAreaOfApplication": "どの領域 /アプリケーションタイプの詳細証明書が会社やサイトに有効です。"
      }
    }
  },
  "bpnSelector": {
    "selectFromList": "リストから選択",
    "enterManually": "手動で入力",
    "selectPlaceholder": "場所のBPNを選択してください",
    "manualPlaceholder": "BPN を入力します (例: BPNL123456789ABC)",
    "validFormat": "有効な BPN 形式",
    "invalidFormat": "無効な BPN 形式です",
    "invalidFormatHint": "形式: BPNL + 12 文字の英数字",
    "formatHint": "形式: BPNL123456789ABC (合計 16 文字)",
    "selected": "選択済み"
  },
  "searchableSelect": {
    "pressEnterToUse": "この BPNA/BPNS を使用するには Enter を押してください",
    "placeholderText": "有効な BPNA/BPNS を入力してください",
    "placeholder": "BPNA/BPNS を選択または入力します"
  },
  "blockNotifications": {
    "title": "通知をブロックする",
    "description": "Catena-X の使いやすいエンドツーエンドのビジネス パートナー証明書管理交換ソリューションへようこそ。",
    "recentNotifications": "最近のお知らせ",
    "totalAffected": "影響を受ける部品の合計",
    "top5": "上位 5 つの Exchange パートナー",
    "sendNotifications": "通知を送信する",
    "sendUpdate": "更新を送信",
    "sentHistory": "送信済み通知履歴",
    "receivedHistory": "受信通知履歴",
    "sendDescription": "Catena-X ネットワークでサイト証明書を作成して共有する",
    "learnMore": "通知のブロックについて詳しく見る",
    "filters": {
      "lastYear": "過去1年間",
      "sixMonths": "6ヶ月",
      "threeMonths": "3ヶ月",
      "oneMonth": "1ヶ月",
      "lastWeek": "先週",
      "selectDateRange": "日付範囲を選択してください",
      "bpnOrCompany": "取引先番号または会社名"
    },
    "stats": {
      "totalAffectedParts": "影響を受ける部品の合計",
      "topExchangePartners": "上位 {count} 件の Exchange パートナー",
      "sentNotifications": "送信済み通知",
      "receivedNotifications": "受信した通知"
    },
    "sentHistoryDescription": "この領域を使用して、パートナーからの証明書データ要求を管理します。",
    "receivedHistoryDescription": "パートナーから受信したブロック通知を表示および管理します。",
    "table": {
      "name": "名前",
      "conversationName": "会話名",
      "problemId": "問題ID",
      "partner": "パートナー",
      "bpn": "BPN番号",
      "createdAt": "で作成されました",
      "createdBy": "作成者",
      "modifiedAt": "変更日",
      "modifiedBy": "変更者",
      "status": "状態",
      "partnerName": "パートナー名",
      "sentBy": "送信者",
      "sentOn": "に送信されました",
      "receivedOn": "受信日"
    },
    "errors": {
      "fetchSentNotifications": "送信された通知を取得できませんでした",
      "fetchStatistics": "通知統計のロードに失敗しました",
      "fetchRecentNotifications": "最近の通知を読み込めませんでした",
      "invalidDateRange": "有効な日付範囲がないと統計を取得できません",
      "sendNotificationFailed": "ブロック通知の送信に失敗しました。",
      "validationFailed": "すべての必須フィールドに入力してください:"
    },
    "confirmationText": "私は理解し、必要な情報をすべて正しく入力したことを確認します。",
    "validityDisclaimer": "T-Systems は、ここに入力されたメタデータ情報の有効性をチェックしません。",
    "generalInformation": "一般情報",
    "jobName": "ジョブ名",
    "jobNamePlaceholder": "ジョブ名を入力してください",
    "receiverBpn": "受信機のBPN",
    "expectedResponseBy": "予想される応答者",
    "success": {
      "notificationSent": "ブロック通知が正常に送信されました",
      "notificationUpdateSent": "ブロック通知の更新が正常に送信されました"
    },
    "groups": {
      "notificationInformation": "お知らせ情報",
      "blockInformationItems": "ブロック情報項目 *",
      "partIdentification": "部品の識別",
      "componentLevelContainment": "コンポーネントレベルの封じ込め",
      "periodAndVolumeLevelContainment": "期間およびボリュームレベルの封じ込め",
      "deliveryInformation": "配送情報",
      "quantities": "数量",
      "sizeOfProductionLot": "生産ロットのサイズ",
      "numberOfPartsPerDeliveryNote": "納品書あたりの部品数",
      "numberOfPartsPerPackage": "パッケージあたりの部品数",
      "locationInContainer": "コンテナ内の場所 (オプション)"
    },
    "fields": {
      "problemId": "問題ID",
      "notificationStatus": "通知ステータス",
      "problemDescription": "問題の説明",
      "updateReason": "更新理由",
      "catenaXId": "Catena-X ID",
      "blockStatus": "ブロックステータス",
      "manufacturingLocationId": "製造場所ID",
      "customerPartId": "顧客部品ID",
      "integrationLevel": "統合レベル",
      "localIdentifiers": "ローカル識別子",
      "key": "鍵",
      "value": "価値",
      "orderNumber": "注文番号",
      "deliveryNoteNumber": "納品書番号",
      "packageNumber": "パッケージ番号",
      "deliveryPlace": "配達場所",
      "productionDate": "製造日",
      "deliveryDate": "配送日",
      "quantity": "量",
      "unit": "ユニット",
      "xPosition": "X 位置",
      "yPosition": "Y 位置",
      "smallLoadCarrierLayer": "小型荷重キャリア層"
    },
    "editNotification": "通知の編集",
    "importJson": {
      "title": "JSONファイルをインポートする",
      "description": "JSON ファイルをアップロードして、提供されたデータをフォームに自動的に入力します。",
      "importButton": "JSONからインポート",
      "dropFileHere": "JSON ファイルをここにドラッグ アンド ドロップします。",
      "selectFile": "ファイルの選択",
      "import": "輸入",
      "success": "フォームデータが JSON から正常にインポートされました",
      "parseError": "JSONファイルの解析に失敗しました",
      "readError": "ファイルの読み込みに失敗しました。"
    },
    "tooltips": {
      "problemDescription": "パーツをブロックする必要がある理由を示す自由テキスト フィールド。",
      "catenaXId": "シリアル化されたパーツまたはバッチの完全に匿名の Catena-X ID。",
      "blockStatus": "ブロック通知内の個々の部分のステータス。",
      "manufacturingLocationId": "コンポーネントの配送元となるサプライヤーの所在地の住所。",
      "updateReason": "以前に提供された破損部品のリストを更新する必要がある理由を説明する自由テキスト。"
    },
    "updateNotification": "更新通知",
    "notificationDetails": "通知の詳細",
    "howTo": {
      "description": "他の Catena-X メンバー企業のデータ オファー カタログをご覧ください。ブロック通知を送受信できます。 ",
      "doc": "ブロック通知の仕組みについて詳しく知りたいですか?"
    }
  },
  "qualityAlert": {
    "sendSuccess": "正常に送信されました！",
    "sendAlert": "品質アラートを送信します",
    "sendInvestigation": "質の高い調査を送信します",
    "updateSuccess": "正常に更新されました！",
    "updateAlert": "品質アラートを更新します",
    "updateInvestigation": "品質調査を更新します",
    "acceptConfirmTitle": "品質警告を受け入れる",
    "acceptConfirmDesc": "[はい]をクリックすると、この品質アラートを受け入れ、適切な行動をとることに同意します。",
    "rejectConfirmTitle": "拒否品質アラート",
    "rejectConfirmDesc": "「はい」をクリックすると、この品質アラートが拒否されます。"
  }
}
